var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#15D47B"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.143 14.143V12A2.143 2.143 0 1 0 12 14.143zm-2.143-6a3.857 3.857 0 1 0 0 7.714h3.428a.43.43 0 0 0 .429-.428V12A3.857 3.857 0 0 0 12 8.143",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.572a6.429 6.429 0 1 0 0 12.857a6.429 6.429 0 0 0 0-12.857M5.143 12a6.857 6.857 0 1 1 13.713 0a6.857 6.857 0 0 1-13.713 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.572a1.071 1.071 0 1 0 0-2.143a1.071 1.071 0 0 0 0 2.143"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc);
export default __webpack_public_path__ + "static/media/sc.34948c5ace7e69725d966c9958f3fd24.svg";
export { ForwardRef as ReactComponent };